import { call, put, takeEvery } from 'redux-saga/effects'
import API from '../../API';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import Cookies from 'js-cookie';

const apiUrl = API.baseURL + `/sign_up`;
async function postApi(data) {
    try {
        const response = axios.post(apiUrl, data, API.options);
        return await response;
    } catch (error) {
        throw error;
    }
}

function* registerPersonal(action) {
    try {
        const response = yield call(postApi, action.data);
        if (response.status == 200 || response.status == 201) {
            // Save confirmation_token to cookies if it exists in the response
            if (response.data && response.data.data && response.data.data.confirmation_token) {
                Cookies.set('confirmation_token', response.data.data.confirmation_token);
                console.log('Signup API - Saved confirmation_token to cookies:', response.data.data.confirmation_token);
            }
            
            // toastr.success('Pegister personal Success', 'You are successfully completed the first step ');
            yield put({ type: 'POST_REGISTER_PERSONAL_SUCCESS', registerPersonal: response.data });
            yield put({ type: 'STORE_ACTIVE_REG_STEP_SUCCESS', activeStep: 2 });
            
        } else {

            response.errors.length != 0 && toastr.error('Pegister personal  failed', response.errors[0]);
        }

    } catch (e) {
        yield put({ type: 'POST_REGISTER_PERSONAL_FAILED', message: e.response.data.data.errors });
    }
}

function* registerPersonalSaga() {
    yield takeEvery('POST_REGISTER_PERSONAL_REQUESTED', registerPersonal);
}

export default registerPersonalSaga;